<template>
  <div id="wrap">
    <header>
      <div class="back">
        <van-icon name="arrow-left" @click="goBack"></van-icon>
      </div>
      <span class="title">{{ activityName }}</span>
      <div class="share" v-if="false">
        <img
          src="http://others-qiniu.shall-buy.com/others-share_icon-20201103141958303984.png"
          alt=""
          style="width: 26px; margin-top: 9px"
          @click="toShare()"
        />
      </div>
    </header>
    <main :style="{ background: colorConfig.background_color_value }">
      <img class="master-img" :src="icon" alt="" />
      <div class="product-wrap">
        <div class="tags-container">
          <span
            v-for="(tag, index) in tags"
            :key="index"
            class="activity-tag"
            @click="changeCategory(tag.value)"
            :style="{
              background:
                categoryId === tag.value
                  ? colorConfig.navigation_button_color_value_selected
                  : colorConfig.navigation_button_color_value,
            }"
            >{{ tag.label }}</span
          >
        </div>
        <van-list
          v-if="categoryId"
          v-model="listData.loading"
          :finished="listData.finished"
          @load="onLoad"
        >
          <div class="products">
            <div
              class="product-content"
              v-for="(product, index) in listData.data"
              :key="index"
            >
              <img class="product-img" :src="product.thumb" alt="商品图片" />
              <div class="product-info">
                <div class="product-name">
                  <img
                    :src="tagIcon"
                    v-if="tagIcon"
                    alt=""
                    class="item-align"
                  />{{ product.name }}
                  >
                </div>
                <div>
                  <div class="flex product-price">
                    <span
                      class="sale-price"
                      :style="{ color: colorConfig.commodity_color_value }"
                      >¥{{ product.show_min_price }}</span
                    >
                    <span
                      class="marking-price"
                      v-if="
                        product.strikeout_price && product.strikeout_price != 0
                      "
                      >¥{{ product.strikeout_price }}</span
                    >
                    <span class="marking-price" v-else
                      >¥{{ product.activity_min_price }}</span
                    >
                  </div>
                  <button
                    class="buy-btn"
                    :style="{
                      background: colorConfig.product_button_color_value,
                    }"
                    @click="goBuy(product)"
                  >
                    立即购买
                  </button>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
      <div class="bottom" v-if="listData.finished">
        <span class="bottom-line-left"></span>
        <span>到底了</span>
        <span class="bottom-line-right"></span>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "PlatformActivity",
  data() {
    return {
      activityId: null, //当前活动id
      activityName: "", //活动标题
      categoryId: null, //当前分类id
      firstLoad: true, //是否首次加载
      tagIcon: "",
      icon: "",
      colorConfig: {},
      listData: {
        loading: false,
        finished: false,
        page: 0,
        pageSize: 10,
        data: [],
      },
      tags: [],
      actyList: [],
      active: 0,
      share_content: "",
    };
  },
  methods: {
    toShare() {
      // 分享
      var title = this.actyList.share_title;
      var bigTitle = this.actyList.share_content;
      var thumb = this.actyList.share_icon;
      let url = location.href.split("?")[0] + "?id=" + this.$route.query.id;
      var result = [bigTitle, title, url, thumb];
      this.params(result, JSON.stringify(result), "toShare");
    },
    onLoad() {
      this.listData.page = this.listData.page + 1;
      this.getProducts(this.listData.page);
    },
    getProducts(page) {
      let body = {
        id: this.activityId,
        list_id: this.categoryId,
        per_page: this.listData.pageSize,
        page: page,
      };
      this.$api
        .post("activity/index/activity/get-normal-list", body)
        .then((res) => {
          console.log(res);
          this.actyList = res;
          this.listData.data = this.listData.data.concat(res.list);
          // 加载状态结束
          this.listData.loading = false;

          // 数据全部加载完成
          if (res.list.length < this.listData.pageSize) {
            this.listData.finished = true;
          }

          if (this.firstLoad) {
            this.icon = res.icon;
            document.title = res.name;
            this.activityName = res.name;
            this.tagIcon = res.tag_icon;
            Object.assign(this.colorConfig, res.orther_config);
            this.firstLoad = false;
            console.log("颜色", this.colorConfig);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeCategory(id) {
      if (this.categoryId !== id) {
        this.categoryId = id;
        this.listData.finished = false;
        this.listData.data = [];
        if(this.actyList.list.length < this.listData.pageSize) {//last page
          this.listData.page = 0;
        }else {
          this.listData.page = 1;
          this.getProducts(1);
        }
        // if (this.actyList.last_page != this.listData.page) {
        //   this.listData.page = 1;
        //   this.getProducts(1);
        // } else {
        //   this.listData.page = 0;
        // }
      }
    },
    goBack() {
      this.params("", "", "goBack");
    },
    goBuy(data) {
      this.params(data.id, data.id, "goBuy");
    },
    isActivityEnd(id) {
      this.$api
        .post("activity/index/activity/get-normal-list", {
          id: this.activityId,
          list_id: id,
          per_page: 1,
          page: 1,
        })
        .then((res) => {
          if (res.activity_status == 0) {
            this.$dialog
              .alert({
                message: "<p>该活动已结束，点击确定返回首页！</p>",
                confirmButtonText: "确定",
                className: "dialog",
              })
              .then(() => {
                this.goBack();
              });
          }
        });
    },
  },
  created() {
    this.activityId = this.$route.query.id;
    //获取活动分类
    this.$api
      .post("activity/index/activity/get-day-goods-type-list", {
        activity_id: this.activityId,
        is_validate_goods: 1,
      })
      .then((res) => {
        console.log("活动分类", res);
        this.tags = res;
        if (res.length != 0) {
          this.categoryId = this.tags[0].value;
          this.isActivityEnd(this.tags[0].value);
        } else {
          this.$dialog
            .alert({
              message: "<p>该活动已结束，点击确定返回首页！</p>",
              confirmButtonText: "确定",
              className: "dialog",
            })
            .then(() => {
              this.goBack();
            });
        }
      });
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.flex {
  display: flex;
}
.item-align {
  vertical-align: middle;
  margin-right: 10px;
  height: 20px;
}
#wrap {
  width: 100%;
  height: 100%;
  /* ios < 11.2 */
  padding-left: constant(safe-area-inset-left);
  padding-top: constant(safe-area-inset-top);
  padding-right: constant(safe-area-inset-right);
  padding-bottom: constant(safe-area-inset-bottom);
  /* ios >= 11.2 */
  padding-left: env(safe-area-inset-left);
  padding-top: env(safe-area-inset-top);
  padding-right: env(safe-area-inset-right);
  padding-bottom: env(safe-area-inset-bottom);
  padding-top: var(--status-height);
}

/*顶部*/
.title {
  font-size: 16px;
  font-weight: 600;
}
.back {
  float: left;
  margin-left: 12px;
}
.share {
  float: right;
  height: 45px;
  margin-right: 12px;
}
header {
  width: 100%;
  height: 45px;
  line-height: 45px;
  background: white;
  text-align: center;
}

/*主体*/
main {
  height: calc(100% - 45px);
  overflow-x: hidden;
  overflow-y: scroll;
}

.master-img {
  width: 100%;
  object-fit: contain;
}
.product-wrap {
  width: 100%;
  padding: 10px 12px 0 12px;
}
.tags-container {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
}
.tags-container::-webkit-scrollbar {
  display: none; /*隐藏滚动条*/
}
.activity-tag {
  font-size: 15px;
  font-weight: 400;
  padding: 5px 10px;
  border-radius: 15px;
  color: white;
  margin-top: 10px;
  margin-right: 15px;
  display: inline-block;
}
/* .products{} */
.products .product-content {
  width: 100%;
  height: 160px;
  background: white;
  border-radius: 6px;
  margin-top: 10px;
  overflow: hidden;
}
.product-img {
  float: left;
  width: 140px;
  height: 140px;
  margin: 10px;
}
.product-name {
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  color: #333333ff;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.product-info {
  width: calc(100% - 160px);
  height: 100%;
  margin-left: 160px;
  padding: 10px 10px 10px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.buy-btn {
  font-size: 16px;
  font-weight: 400;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 10px;
}
.product-price {
  align-items: flex-end;
  margin-bottom: 10px;
}
.sale-price {
  font-size: 18px;
  font-weight: 600;
  color: #ec860eff;
  line-height: 20px;
}
.marking-price {
  font-size: 12px;
  font-weight: 400;
  color: #b3b3b3ff;
  text-decoration: line-through;
  margin-left: 10px;
}

/*底部*/
.bottom {
  width: 100%;
  padding: 20px 0;
  color: white;
  font-size: 12px;
  font-weight: 400;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bottom-line-left {
  display: inline-block;
  width: 30px;
  height: 1px;
  background-image: linear-gradient(to right, #ffffff00, #ffffffff);
  margin-right: 10px;
}
.bottom-line-right {
  display: inline-block;
  width: 30px;
  height: 1px;
  background-image: linear-gradient(to left, #ffffff00, #ffffffff);
  margin-left: 10px;
}
</style>
